module.exports = "query todoGiftsProducts {\n\n  todoGiftsProducts {\n    brand_name\n    tax\n    products{\n      min_value\n      max_value\n      card_identificator\n    }\n\n    # expiration_in_months\n\n    # perform_in\n    # stores\n    # site\n    # image_thumb\n    # image_small\n    # image_default\n    # brand_description\n    # steps_to_use\n    # comments\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/graphQL/queries/TodoGiftsProducts.graphql
// module id = JzKe
// module chunks = 1624